import { createStore } from "vuex";

import createPersistedState from "vuex-persistedstate";

import cloneDeep from "lodash/cloneDeep";

import { chat } from "./chat/chat";

import { filters } from "./filters/filters";

import { notifications } from "./notifications/notifications";

import {previousRoute} from "./previousRoute/previousRoute";

import Models from "./models/models";
import getters from "./getters/getters";
import mutations from "./mutations/mutations";
import actions from "./actions/actions";


import router from "@/router/router-loader";

const models = new Models();
const stateModel = models.state();

const authState = createPersistedState({
  paths: [
    "jobDistances",
    "token",
    "user",
    "chat.list",
    "chat.unread",
    "chat.messages",
    "notifications.messages",
    "notifications.unread",
    "pages.backPage",
    "pages.auth",
    "pages.search",
    "pages.job",
    "pages.report",
    "pages.dispute",
    "pages.verify",
    "pages.jobListing",
    "jobs",
    "shifts",
    "notifications",
  ],
});

export default createStore({
  // plugins: [createPersistedState()],
  state: cloneDeep(stateModel),
  // state: stateModel,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {
    chat: chat(router),
    notifications,
    filters,
    previousRoute
  },
  plugins: [authState],
});
